export default "__VITE_ASSET__efc6df9e__"